import { render, staticRenderFns } from "./ruta-familias.vue?vue&type=template&id=731cf8cc&"
import script from "./ruta-familias.vue?vue&type=script&lang=js&"
export * from "./ruta-familias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports